function filterAllowedModuleSelfDiagnosisStatusDefinition(vm, def) {
  return vm.$hasUserPermission('PER014') ? [def] : [];
}

function filterAllowedResetDefinition(vm, def) {
  return vm.$hasUserPermission('PER030') ? [def] : [];
}

export default {
  getHeaders(vm) {
    return [
      {
        key: 'company',
        label: vm.$t('network-status.fields.company'),
        sortable: true,
        sortDirection: 'desc',
        colspan: 2,
      },
      {
        key: 'installation',
        label: vm.$t('network-status.fields.installation'),
        sortable: true,
        sortDirection: 'desc',
      },
      {
        key: 'asset',
        label: vm.$t('network-status.fields.asset'),
        sortable: false,
      },
      {
        key: 'name',
        label: vm.$t('network-status.fields.module'),
        sortable: false,
      },
      {
        key: 'address',
        label: vm.$t('network-status.fields.address'),
        sortable: false,
      },
      {
        key: 'ip',
        label: vm.$t('network-status.fields.ip'),
        sortable: false,
      },
      {
        key: 'network',
        label: vm.$t('network-status.fields.network-status'),
        sortable: true,
      },
      {
        key: 'moduleStatus',
        label: vm.$t('network-status.fields.module-status'),
        sortable: true,
      },
      ...filterAllowedModuleSelfDiagnosisStatusDefinition(vm, {
        key: 'moduleSelfDiagnosisStatus',
        label: vm.$t('network-status.fields.module-self-diagnosis-status'),
        sortable: false,
      }),
      ...filterAllowedResetDefinition(vm,
      {
        key: 'reset',
        label: vm.$t('network-status.fields.reset'),
        tooltip: vm.$t('messages.MI096.message'),
        sortable: false,
      }),
    ];
  },
  getLevels(vm) {
    return [
      {
        childrenProperty: 'modules',
        fields: [
          {
            key: 'company',
            colspan: 2,
          },
          {
            key: 'installation',
          },
          {
            key: 'holder',
            colspan: 4,
          },
          {
            key: 'networkStatus',
            slotName: 'allLevels.networkStatus',
          },
          {
            key: 'status',
            slotName: 'allLevels.status',
          },
          ...filterAllowedModuleSelfDiagnosisStatusDefinition(vm, {
            key: 'moduleSelfDiagnosisStatus',
            slotName: 'allLevels.moduleSelfDiagnosisStatus',
          }),
          ...filterAllowedResetDefinition(vm,
          {
            key: 'reset',
            slotName: 'allLevels.reset',
          }),
        ],
      },
      {
        fields: [
          {
            key: 'levelBar',
            class: 'network-status-table__cell-modules-level-bar',
          },
          {
            key: 'company',
          },
          {
            key: 'installation',
          },
          {
            key: 'asset',
          },
          {
            key: 'name',
          },
          {
            key: 'address',
          },
          {
            key: 'ip',
          },
          {
            key: 'networkStatus',
            slotName: 'allLevels.networkStatus',
          },
          {
            key: 'status',
            slotName: 'allLevels.status',
          },
          ...filterAllowedModuleSelfDiagnosisStatusDefinition(vm, {
            key: 'moduleSelfDiagnosisStatus',
            slotName: 'allLevels.moduleSelfDiagnosisStatus',
          }),
        ],
      },
    ];
  },
};
